import { operators } from '$lib/utilities/operators';
import { getObjectField } from 'cando-util';

export const isKeyValueTrue = (question, formData, key) => {
	if (getObjectField(question, key.split('.'))?.value === 'true') {
		return true;
	} else {
		if ((getObjectField(question, key.split('.'))?.value || '').includes('|')) {
			const conditions = (getObjectField(question, key.split('.'))?.value || '').split('||');

			let result = false;

			for (const condition of conditions) {
				const [fld, opStr, ...val] = condition.split('|');
				const f = operators.filter((o) => o.firestore === opStr)?.[0]?.javascript;

				const processedVal = val.map(e => e === 'undefined' ? undefined : e);
				if (processedVal.includes('true')) {
					processedVal.push(true);
				}
				if (processedVal.includes('false')) {
					processedVal.push(false);
				}

				const processedData = getObjectField(formData, fld.split('.'));

				if (typeof f === 'function' && (processedData || val.includes('undefined'))) {
					result = f(processedData, processedVal);
				}

				// if (question.label === 'Text Payment Link') {
				// console.log({ result, key, fld, opStr, val, a: formData?.[fld], processedVal, processedData, f: f(processedData, processedVal), formData, question });
				// }

				if (result) return result;
			}
			return false;
		} else {
			return false;
		}
	}
};
